document.querySelectorAll('.addToCalendar').forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault();

    const title = button.getAttribute('data-title');
    const details = button.getAttribute('data-details');
    const location = button.getAttribute('data-location');
    const start = formatDate(button.getAttribute('data-start'));
    const end = formatDate(button.getAttribute('data-end'));

    // 1️⃣ Open Google Calendar in new tab
    const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      title
    )}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(
      location
    )}&dates=${start}/${end}`;
    window.open(googleUrl, '_blank');

    // 2️⃣ Create and auto-download ICS for Apple Calendar
    const icsContent = createICS(title, details, location, start, end);
    const blob = new Blob([icsContent], {
      type: 'text/calendar;charset=utf-8',
    });
    const icsUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = icsUrl;
    a.download = `${title.replace(/\s+/g, '_')}.ics`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(icsUrl);
  });

  function formatDate(dateString) {
    const date = new Date(dateString.replace(' ', 'T'));
    return date.toISOString().replace(/[-:]/g, '').replace('.000', '');
  }

  function createICS(title, details, location, start, end) {
    return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//CancerCouncil//AddToCalendar//EN
BEGIN:VEVENT
UID:${Date.now()}@yoursite.com
DTSTAMP:${start}
DTSTART:${start}
DTEND:${end}
SUMMARY:${title}
DESCRIPTION:${details}
LOCATION:${location}
END:VEVENT
END:VCALENDAR`;
  }
});
